<template>
  <div class="columns is-centered">
    <div class="column">
      <user-edit></user-edit>
    </div>
  </div>
</template>

<script>
  import UserEdit from '@/components/users/UserEdit'

  export default {
    components: {
      'user-edit': UserEdit
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/auth/Signup.vue